export var CustomRouteType = /*#__PURE__*/function (CustomRouteType) {
  CustomRouteType["ROOT"] = "ROOT";
  CustomRouteType["CHILD"] = "CHILD";
  CustomRouteType["ADDON"] = "ADDON";
  return CustomRouteType;
}(CustomRouteType || {});